import { t } from "i18next";

import { Link } from "@mui/material";

interface ArticleExternalTextLinkProps {
  url: string;
  text: string;
}

export const getArticleOpensInNewTabAriaLabel = (linkText: string): string =>
  t("components.articlePage.opensInNewTabAriaLabel", { linkText });

const ArticleExternalTextLink = (props: ArticleExternalTextLinkProps) => (
  <Link
    href={props.url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={getArticleOpensInNewTabAriaLabel(props.text)}
  >
    {props.text}
  </Link>
);

export default ArticleExternalTextLink;
